import type { Company, TagAttributeDto, UserDto } from "~/types/api";
import { BaseAPI } from "./base";
import { distinctBy } from "~/utils/array-util";
import type { ApiResponse, CompanySettings } from "~/types/ui";

export class CompanyApi extends BaseAPI {
  async getCompanyByUser(): Promise<ApiResponse<Company>> {
    return this.get<Company>(`users/${this.user()}/company`);
  }

  async getCompanies(): Promise<ApiResponse<Company[]>> {
    return this.get<Company[]>(`companies/all`);
  }
  
  async getUsers(): Promise<ApiResponse<User[]>> {
    return this.get<User[]>(`companies/${this.company()}/users`);
  }

  async getCompanyUsers(): Promise<ApiResponse<UserDto[]>> {
    return this.get<UserDto[]>(`companies/${this.company()}/users`);
  }

  async getCompanyExternalUsers(): Promise<ApiResponse<UserDto[]>> {
    return this.get<UserDto[]>(`companies/external/users/${this.company()}`);
  }

  async uploadWhiteLabelImage(file: File): Promise<ApiResponse<void>> {
    const formData = new FormData();
    formData.append("image", file);
    return this.post<void>(`companies/white-label/${this.company()}`, formData);
  }

  async deleteWhiteLabelImage(): Promise<ApiResponse<void>> {
    return this.delete(`companies/white-label/${this.company()}`);
  }

  async settings(): Promise<ApiResponse<CompanySettings>> {
    return this.get<CompanySettings>(`settings/company/${this.company()}`);
  }

  async settingsUpdate(data: CompanySettings): Promise<ApiResponse<null>> {
    return this.put<null>(`settings/company/${this.company()}`, data);
  }

  async attributes(): Promise<ApiResponse<TagAttributeDto[]>> {
    let resp = await this.get<TagAttributeDto[]>(
      `tag/company/${this.company()}/attributes`,
    );

    if (!resp.ok) return resp;

    resp.data = distinctBy(resp.data ?? [], (a) => a.normalizedName);
    return resp;
  }
}
